// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2P4J-","footer":"ModalFilter_footer__13owK"};